module.exports = __webpack_public_path__ + "img/timer-stop-outline.aaed73ab.svg";